import { render } from "./PlayerState.vue?vue&type=template&id=55422850&scoped=true"
import script from "./PlayerState.vue?vue&type=script&lang=js"
export * from "./PlayerState.vue?vue&type=script&lang=js"

import "./PlayerState.vue?vue&type=style&index=0&id=55422850&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tchutchu/tchutchu/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55422850"]])

export default __exports__